
import { User, UserRoomState, zawaroom } from '@/utils/models';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import StatusIcon from '@/components/room/users/StatusIcon.vue';
@Component({ components: { StatusIcon } })
export default class RoomsMemberListItem extends Vue {
  @Prop() private user!: User;
  @Prop() private state!: UserRoomState;

  get userData(): User {
    return this.userState?.user || this.user;
  }
  get userState(): UserRoomState {
    return this.state;
  }
  get userNameFirstLetter(): string {
    return this.userData?.name.charAt(0) ?? '';
  }
  get statusId() {
    return this.userState?.status ?? 'Offline';
  }

  @Emit()
  clickMember(ev: MouseEvent): { rect: any; userId: string } {
    ev.stopPropagation();
    let rect = (ev.target as HTMLDivElement).getBoundingClientRect();
    return { rect, userId: this.userData.id };
  }
}
